import React from "react";

function Text(props) {
    const { as = "span", className } = props;
    const Ele = as;
    return <Ele className={className}>{props.children}</Ele>;
}

export default Text;
